<wchfs-validation-error class="wchfs-form-field-errors">
  <ng-container>
    {{ textValue }}
  </ng-container>
</wchfs-validation-error>
